/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_Create_Source_EmptyInputs */

const en_statement_tree_create_source_empty = /** @type {(inputs: Statement_Tree_Create_Source_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empty tree`)
};

const nl_statement_tree_create_source_empty = /** @type {(inputs: Statement_Tree_Create_Source_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lege stamboom`)
};

/**
* | output |
* | --- |
* | "Empty tree" |
*
* @param {Statement_Tree_Create_Source_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_create_source_empty = /** @type {((inputs?: Statement_Tree_Create_Source_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Create_Source_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_create_source_empty(inputs)
	return en_statement_tree_create_source_empty(inputs)
});